import { TrackingProfile } from "../../lib/accountUtils";
import createReducer from "../../lib/createReducer";
import { LOAD_TRACKINGDATA, LoadTrackingDataActionPayload } from "../actions";

export interface TrackingDataState extends TrackingProfile {
	isLoaded: boolean;
};

const initialState = {
	isLoaded: false,
};

const handleTrackingDataData = (
	state: TrackingDataState, 
	{
		email,
		firstname,
		lastname,
		initialinterest,
		lastupdated,
	}: LoadTrackingDataActionPayload): TrackingDataState => ({
  ...state,
	email,
	firstname,
	lastname,
	initialinterest,
	lastupdated,
	isLoaded: true,
});

const handlers = {
  [LOAD_TRACKINGDATA + '_FULFILLED']: handleTrackingDataData,
};

export default createReducer(handlers, initialState);